"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLevel = void 0;
var NotificationLevel;
(function (NotificationLevel) {
    NotificationLevel[NotificationLevel["High"] = 10] = "High";
    NotificationLevel[NotificationLevel["Medium"] = 5] = "Medium";
    NotificationLevel[NotificationLevel["Low"] = 0] = "Low";
})(NotificationLevel || (exports.NotificationLevel = NotificationLevel = {}));
//# sourceMappingURL=INotification.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/model/INotification.js
// module id = 1752
// module chunks = 0